import type { ReactElement, ReactNode } from 'react'

interface Props {
  condition: boolean
  wrapper: (children: ReactNode) => ReactElement
  children: ReactNode
}

export const ConditionalWrapper = ({ condition, wrapper, children }: Props) => {
  return condition ? wrapper(children) : children
}
